import React from 'react';
import { ScaleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink px-5 py-10 md:px-8" data-id="element-79">
      <div className="mx-auto max-w-5xl text-center" data-id="element-80">
        <div className="flex items-center justify-center gap-2 text-accent" data-id="element-81">
          <ScaleIcon size={17} aria-hidden="true" data-id="element-82" />
          <p className="font-display text-lg font-semibold" data-id="element-83">
            CONVERSION ELITE™
          </p>
        </div>
        <p className="mt-4 text-xs leading-relaxed text-stone-500" data-id="element-84">
          © 2026 Conversion Elite™ — Todos los derechos reservados. Prohibida
          la reproducción total o parcial sin autorización.
        </p>
      </div>
    </footer>;
}